import moment = require("moment");
import * as React from "react";
// tslint:disable-next-line:no-implicit-dependencies
import {Subscription} from "rxjs";
import {Buttons} from "../../../../components/buttons/Buttons";
import {
    RangedDatePickerWithOptions,
    RangedDatePickerWithOptionsOptions,
} from "../../../../components/rangeddatepicker/RangedDatePickerWithOptions";
import RangedDatePickerWithOptionsController
    from "../../../../components/rangeddatepicker/RangedDatePickerWithOptionsController";
import {I18n} from "../../../../components/Utils/i18n";
import {HaccpColours, HaccpController} from "../HaccpController";
import {HaccpLegend} from "./HaccpLegend";

import "./HaccpHeader.scss";
import {ChipButton} from "../../../../components/buttons/ChipButton";
import {getChipColor} from "../../alarms/subfilters/Commons";

declare var LOCALE: string;

const LAST_WEEK = -7;
const LAST_MONTH = -1;
const MAX_DATE_RANGE_INTEVAL = 30;
const DAY_UNIT = "day";
const MONTH_UNIT = "month";

export interface HaccpHeaderProps {
    controller: HaccpController;
    hasActiveConfigurations: boolean;
    texts: {
        date: string,
        today: string,
        lastWeek: string,
        lastMonth: string,
        custom: string,
        from: string,
        to: string
        legend: {
            legend: string,
            temperature: string,
            deviation: string,
            defrost: string,
            noData: string,
            off: string,
            high: string,
            low: string,
            edit: string,
        },
        extremesChipButtonLabel: string,
        exportLabel: string,
    };
    locationGuid?: string;
}

export interface HaccpHeaderState {
    showExtremes: boolean;
    installationDate?: Date;
}

export class HaccpHeader extends React.Component<HaccpHeaderProps, HaccpHeaderState> {

    private dateSubscription: Subscription;
    private installationDateSubscription: Subscription;

    private selectionOptions: RangedDatePickerWithOptionsOptions[];

    private controller: RangedDatePickerWithOptionsController;

    constructor(props) {
        super(props);
        this.controller = new RangedDatePickerWithOptionsController({});
        this.selectionOptions = [
            {
                optionName: this.props.texts.today,
                optionRange: {
                    start: moment().startOf(DAY_UNIT).toDate(),
                    end: moment().endOf(DAY_UNIT).toDate(),
                },
            },
            {
                optionName: this.props.texts.lastWeek,
                optionRange: {
                    start: moment().add(LAST_WEEK, DAY_UNIT).startOf(DAY_UNIT).toDate(),
                    end: moment().endOf(DAY_UNIT).toDate(),
                },
            },
            {
                optionName: this.props.texts.lastMonth,
                optionRange: {
                    start: moment().add(LAST_MONTH, MONTH_UNIT).startOf(DAY_UNIT).toDate(),
                    end: moment().endOf(DAY_UNIT).toDate(),
                },
            },
        ];

        this.state = {
            showExtremes: false,
        };
    }

    public componentDidMount() {

        this.props.controller.toggleExtremes(false);

        this.installationDateSubscription = this.props.controller.listenToInstallationDate((installationDate) => {
            this.setState({
                installationDate,
            });
        });

        this.dateSubscription = this.controller.listen(({start, end}) => {
            this.props.controller.changeDate({start, end});
        });
    }

    public componentWillUnmount() {
        this.dateSubscription.unsubscribe();
        this.installationDateSubscription.unsubscribe();
    }

    public render() {
        return (
            <div className={"form"}>
                <div className={"action-buttons"}>
                    <div className={"datepicker"} style={{zIndex: 7}}>
                        <p>{this.props.texts.date}</p>
                        <RangedDatePickerWithOptions
                            options={this.selectionOptions}
                            controller={this.controller}
                            customText={this.props.texts.custom}
                            maxInterval={MAX_DATE_RANGE_INTEVAL}
                            maxDate={moment().endOf("day").toDate()}
                            dateFormat={I18n.getLocaleDateFormat(LOCALE)}
                            minDate={this.state.installationDate}
                            fromLabel={this.props.texts.from}
                            toLabel={this.props.texts.to}
                            useETUIcomponent={true}
                        />
                    </div>
                    <div
                        className={"actions"}
                    >
                        {this.props.hasActiveConfigurations
                            ? <ChipButton
                                onChange={this.onChipChangeState}
                                checked={this.state.showExtremes}
                                label={this.props.texts.extremesChipButtonLabel}
                                color={getChipColor(false, this.state.showExtremes)}
                                accentColor={"var(--blue)"}
                                margin={"0"}
                                showAccentCircle={false}
                            />
                            : null}
                        {this.props.hasActiveConfigurations
                            ? <Buttons.ExportToExcel
                                label={this.props.texts.exportLabel}
                                onClick={
                                    (this.props.locationGuid)
                                        ? () => this.props.controller.downloadLocationExcel(this.props.locationGuid)
                                        : () => this.props.controller.downloadAllReportExcel()
                                }
                            />
                            : null
                        }
                    </div>

                </div>
                <HaccpLegend
                    hotterDeviations={HaccpColours.hotterDeviation}
                    colderDeviations={HaccpColours.colderDeviation}
                    inRange={HaccpColours.inRange}
                    cleaning={HaccpColours.cleaning}
                    defrost={HaccpColours.defrost}
                    off={HaccpColours.off}
                    noData={HaccpColours.noData}
                    texts={this.props.texts.legend}
                />
            </div>
        );
    }

    private onChipChangeState = (e) => {
        this.setState({
            showExtremes: e,
        }, () => {
            this.props.controller.toggleExtremes(this.state.showExtremes);
        });
    }
}
